import { normalizeLocale, type SupportedLocale } from './config';

const MEMBER: Record<SupportedLocale, string> = {
  en: 'Member',
  ar: 'عضو',
  es: 'Miembro',
  'pt-BR': 'Membro',
  fr: 'Membre',
  it: 'Membro',
  ko: '멤버',
  de: 'Mitglied',
  ja: 'メンバー',
  hi: 'सदस्य',
  ru: 'Участник',
  zh: '成员',
  'zh-TW': '成員',
  vi: 'Thành viên',
  id: 'Anggota',
};

export function memberDisplayNameFallback(locale?: string | null): string {
  return MEMBER[normalizeLocale(locale)];
}
